import {IBaseWorkflowState} from "../../server/models/workflow/IBaseWorkflowState";
import {IGenericWorkflowActionResult} from "./IGenericWorkflowActionResult";

export enum WorkflowStates {
    DONE = "DONE",
    FAILED = "FAILED"
}

export interface IWorkflowState extends IBaseWorkflowState {
    action: (arg: any) => Promise<IGenericWorkflowActionResult>;
    actionArgs: any;
    actionResultInfo: any[];
    state: WorkflowStates;
    isForced: boolean;
    repeatIndexesOnFailure: number[];
    lastUpdatedAt: number;
    skip: boolean;
    message: string;
}